import homeVideo from "fragments/homeVideos/homeVideo"
import gql from "graphql-tag"

const BULK_UPDATE_STORE_LINKS = gql`
  ${homeVideo}

  mutation bulkUpdateStoreLinks($input: BulkStoreToggleInput!) {
    bulkUpdateStoreLinks(input: $input) {
      homeVideo {
        ...HomeVideo
      }
      updatedStoreLinkIds
    }
  }
`

export default BULK_UPDATE_STORE_LINKS
